import SeverityIssue from "./SeverityIssue";
const SeverityTab = () => {
  return (
    <div className=" row">
      <div className="col-lg-6">
        <SeverityIssue />
      </div>
      <div className="col-lg-6">{/* <Issue /> */}</div>
    </div>
  );
};
export default SeverityTab;
